
import {
cancelOrders
} from "@/common/js/api.js";
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Msg from 'vux/src/components/msg/index.vue'


export default {
components: {
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale,
Selector,
Divider,
Msg
},
methods: {
warnPlugin (msg) {
this.$vux.alert.show({
title: '注意',
content: msg,
onShow () {

},
onHide () {





}
})
},
warnPluginAuto (msg) {
this.warnPlugin(msg)
setTimeout(() => {
this.$vux.alert.hide()
}, 3000)
},
closePage(){
this.$router.push({ path: "/yueIndex" });
}
},
data() {
return {
description: '没有该订单',
title: '没有该订单',
icon: "warn",
weight: '没有该订单',
address: '没有该订单',
bookingTime: '没有该订单',
canCancle: false,

};
},created() {


let self = this;
self.orderId = this.$route.query.orderId;
if (this.$route.query.orderId) {
self.icon = "success"
self.title = "预约成功"
self.description = "请在“鸥燕”小程序，进入个人中心查看订单"
self.canCancle = true
}

if ( !this.$route.query.weight || !this.$route.query.address || !this.$route.query.bookingTime) {
self.title = "非法操作"
}else{
self.weight = this.$route.query.weight;
self.address = this.$route.query.address;
self.bookingTime = this.$route.query.bookingTime;
}

},
mounted() {

}
};



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/BookSuccess.vue